import { Box, Link, Typography, Container, Divider } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Page from "../component/Page";
import partners from "../component/Utils/partners";

export default function About() {
  const rounter = useRouter();
  const [stationsNumber, setStationsNumbers] = useState(0);
  useEffect(() => {
    fetch("/api/getStationsInfo").then(data => data.json()).then((json) => {
      setStationsNumbers(Object.keys(json).length)
    })
  }, []);
  return (
    <Page>
      <Container sx={{ my: 10 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h2" sx={{ pb: 5 }}>
            About Us
          </Typography>
          <Typography variant="h6" sx={{ textAlign: "center" }}>
            The Kentucky Climate Center is located in the Department of Earth,
            Environmental, and Atmospheric Sciences (EEAS) on the campus of
            Western Kentucky University in Bowling Green, Kentucky. Our main
            office is in Room 340 of the Environmental Sciences and Technology
            Building shown on the{" "}
            <Link href="https://www.wku.edu/campusmap.php" target={"_blank"}>campus map</Link>.
          </Typography>
        </Box>
        <Divider sx={{ my: 8 }}></Divider>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            pb: 5,
          }}
        >
          <Box sx={{ flex: 1, minWidth: 300 }}>
            <Typography variant="h5" sx={{ textAlign: "center", py: 5 }}>
              Measuring Weather. Establishing <span style={{ color: "#cf152d" }}>Climate</span>.
            </Typography>
          </Box>
          <Box sx={{ flex: 1, minWidth: 300, textAlign: "justify" }}>
            <Typography variant="body1">
              The Kentucky Climate Center (KCC) is the state's official climate
              office, responsible for the collection, dissemination, and
              assessment of weather and climate information across the
              Commonwealth. Located at Western Kentucky University, the KCC
              leads research, educational, and outreach activities in
              collaboration with federal, state, and local governments; private
              sector firms; universities; and non-profit organizations. KCC
              partners include the American Association of State Climatologists
              (AASC); Kentucky Dept. of Public Health; Kentucky Dept. of
              Transportation; the National Weather Service; NOAA Midwest
              Regional Climate Center; the University of Kentucky; and the USDA.
              In its ongoing efforts to enhance local weather data collection,
              the KCC operates and maintains the Kentucky Mesonet, a network of
              {" " + stationsNumber} weather stations deployed in 71 counties across the state. Each
              station collects real-time, high-quality soil and atmospheric
              data, including air temperature, relative humidity, pressure,
              precipitation, wind speed and direction, solar radiation, and soil
              temperature and moisture. All data are collected,
              quality-controlled, archived, and disseminated to users in
              real-time, 24/7. These data support a variety of weather-sensitive
              industries and emergency management operations statewide.
            </Typography>
            <Typography variant="body1">
              The KCC also supports basic and applied research. Its Applied
              Climatology program engages in research in a wide variety of
              areas, including agriculture, emergency management, hydrology,
              public health, transportation, and wildfire. The KCC internship
              program supports student research and engagement, providing
              students with hands-on experience in communication, data analysis,
              programming, statistics, visualization, and writing. Through these
              observational, research, and educational efforts, the KCC is
              working to help mitigate the negative impacts from high-impact
              weather and climate. Please contact us at{" "}
              <Link href="mailto:kyclimate@wku.edu">kyclimate@wku.edu</Link> if
              you would like to collaborate with us on any of these activities.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {partners.map((i) => (
            <img
              key={i.name}
              src={i.logo}
              style={{
                padding: 15,
                mixBlendMode: "multiply",
                height: 75,
                cursor: "pointer",
              }}
              onClick={() => rounter.push(i.url)}
              alt={i.name}
            ></img>
          ))}
        </Box>
      </Container>
    </Page>
  );
}
